import React, { useMemo, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import NumberKeyboard from "./numberKeyboard";
import { KioskStepContainer } from "../styled/common"; // 경로 맞춰

const PinConfirmFields = ({ transformValue, formData, handleChangeInput }) => {
  const [show, setShow] = useState(false);

  const raw = useMemo(() => {
    return (formData.passwordConfirm || "").replace(/\D/g, "").slice(0, 4);
  }, [formData.passwordConfirm]);

  const displayValue = useMemo(() => {
    if (!raw) return "";
    return show ? raw : "●".repeat(raw.length);
  }, [raw, show]);

  return (
    <KioskStepContainer
      className="slideContent"
      style={{ transform: `translateX(${transformValue}%)` }}
    >
      <div className="wrap">
        <div className="header">
          <div className="badge">STEP 4</div>
          <div className="title">비밀번호 확인</div>
          <div className="sub">같은 숫자 4자리를 한 번 더 입력해주세요.</div>
        </div>

        <div className="card">
          <div className="inputBar hasRight">
            <input type="text" value={displayValue} readOnly placeholder="●●●●" />
            <button
              type="button"
              className="rightBtn"
              onClick={() => setShow((v) => !v)}
              aria-label={show ? "비밀번호 숨기기" : "비밀번호 보기"}
            >
              {show ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <div className="body">
            <NumberKeyboard
              type="passwordConfirm"
              inputValue={formData.passwordConfirm}
              handleChangeInput={handleChangeInput}
            />
          </div>
        </div>
      </div>
    </KioskStepContainer>
  );
};

export default PinConfirmFields;